import { Box, Typography, Container, Link } from "@mui/material"
import Grid from "@mui/material/Grid";
// Local imports kept for fallback or reference
import tellwellFacebookIcon from "../../images/tellwell-facebook-icon.png";
import tellwellInstagramIcon from "../../images/tellwell-instagram-icon.png";
import tellwellxIcon from "../../images/tellwell-x-icon.png";
import tellwellYoutubeIcon from "../../images/tellwell-youtube-icon.png";
import tellwellLinkedinIcon from "../../images/tellwell-linkedin-icon.png";
import tellwellLogo from "../../images/tellwell-blue-logo.png";
import { useState, useEffect } from "react";

const currentYear = new Date().getFullYear();
const externalURLIcons = "https://static.tellwell.ca/bookcatalog-assets";

const Footer = () => {

  const [externalLink] = useState("https://tellwellpublishing.com");

  const footerData = [
    {
      title: "Company",
      links: [
        { text: "About Us", href: `${externalLink}/about-us` },
        { text: "Reviews", href: `${externalLink}/testimonials` },
        { text: "Our Books", href: `${externalLink}/our-books`},
        { text: "Contact Us", href: `${externalLink}/contact-us` },
      ],
    },
    {
      title: "Services",
      links: [
        { text: "Editing", href: `${externalLink}/services/editing` },
        { text: "Printing", href: `${externalLink}/services/printing` },
        { text: "Design", href: `${externalLink}/services/design` },
        { text: "Book Coaching", href: `${externalLink}/services/book-coaching` },
        { text: "Illustrations", href: `${externalLink}/services/illustrations` },
        { text: "Audiobooks", href: `${externalLink}/services/audiobooks` },
        { text: "Book Marketing", href: `${externalLink}services/marketing-publicity` },
        { text: "Ghostwriting", href: `${externalLink}/services/ghostwriting` },
        { text: "Distribution", href: `${externalLink}/services/distribution` },
      ],
    },
    {
      title: "Packages",
      links: [
        { text: "Book Publishing", href: `${externalLink}/packages/` },
        { text: "Children's Publishing", href: `${externalLink}/packages/children-publishing` },
        { text: "Premium Nonfiction Packages", href: `${externalLink}//packages/premium-nonfiction` },
      ],
    },
    {
      title: "Free Resources",
      links: [
        { text: "Book a Consultation", href: `${externalLink}/book-consultation` },
        { text: "Guide to Publishing", href: "https://publish.com/usa-publish/" },
        { text: "Blog", href: "http://blog.tellwell.ca/" },
      ],
    },
    {
      title: "Quick Links",
      links: [
        { text: "Royalty Estimator", href: `${externalLink}/royalty-estimator` },
        { text: "Price List (USD)", href: `${externalLink}/price-list` },
        { text: "Author Advocate Program", href: `${externalLink}/advocate` },
        { text: "Tellwell Ambassador Program", href: `${externalLink}/ambassador` },
        { text: "Referral Program Rules", href: `${externalLink}/referral-program-rules` },
      ],
    },
  ];


  return (
    <Box className="footer" sx={{ bgcolor: "#222222fc", color: "white", width: "100%", minHeight: { xs: 350, md: 250 } }}>
      <Container maxWidth="lg">
        <Box className="linksFooter" sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(5, auto)" }, boxSizing: "border-box", alignItems: "baseline" }}>
          {footerData.map((section) => {

            const footerLinkClass = section.title
              .replace(/[^a-zA-Z0-9]/g, " ")
              .split(" ")
              .map((word, index) =>
                index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1)
              )
              .join("");

            return (
              <Box key={section.title} sx={{ paddingLeft: "10px" }} className="footerSection">
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  {section.title}
                </Typography>

                <Box className={`footer-${footerLinkClass}`}>
                    {section.links.map((link) => (
                      <Link
                        key={link.text}
                        href={link.href}
                        color="inherit"
                        underline="none"
                        display="block"
                        sx={{ mt: 1, "&:hover": { textDecoration: "underline" } }}
                      >
                        {link.text}
                      </Link>
                    ))}
                </Box>
              </Box>
            );
          })}
        </Box>


      </Container>
      <Box className="footerBottom">
        <Container maxWidth="lg" sx={{ marginLeft: "auto", marginRight: "auto" }}>
          <Grid container>
            <Grid className="socialMediaIcons" rowSpacing={1} size={{ xs: 12, md: 4 }} sx={{ gap: "15px", alignItems: "center", display: "flex", flexWrap: "wrap" }}>
              <Link href="https://twitter.com/tellwelltalent" style={{ textDecoration: "none", color: "#ffffff" }} component="a" {...{ name: "x-icon" }}>
                <img src={`${externalURLIcons}/tellwell-x-icon.png`} alt="Logo" width="32" height="32" style={{ width: 40, height: 40 }} />
              </Link>
              <Link href="https://www.linkedin.com/company/tellwell-talent" style={{ textDecoration: "none", color: "#ffffff" }} component="a" {...{ name: "linkedin-icon" }}>
                <img src={`${externalURLIcons}/tellwell-linkedin-icon.png`} alt="Logo" width="32" height="32" style={{ width: 40, height: 40 }} />
              </Link>
              <Link href="https://www.instagram.com/tellwellpublishing/" style={{ textDecoration: "none", color: "#ffffff" }} component="a" {...{ name: "instagram-icon" }}>
                <img src={`${externalURLIcons}/tellwell-instagram-icon.png`} alt="Logo" width="32" height="32" style={{ width: 40, height: 40 }} />
              </Link>
              <Link href="https://www.facebook.com/TellwellPublishing/" style={{ textDecoration: "none", color: "#ffffff" }} component="a" {...{ name: "fb-icon" }}>
                <img src={`${externalURLIcons}/tellwell-facebook-icon.png`} alt="Logo" width="32" height="32" style={{ width: 40, height: 40 }} />
              </Link>
              <Link href="https://www.youtube.com/@tellwellpublishing" style={{ textDecoration: "none", color: "#ffffff" }} component="a" {...{ name: "youtube-icon" }}>
                <img src={`${externalURLIcons}/tellwell-youtube-icon.png`} alt="Logo" width="32" height="32" style={{ width: 40, height: 40 }} />
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }} sx={{alignContent: "center", display: "flex", justifyContent: "center"}}>
              <Link href="/" style={{ textDecoration: "none", color: "#ffffff" }} data-qa="footer-logo">
                <img src={`${externalURLIcons}/tellwell-blue-logo.png`} alt="Tellwell Logo" width="170" height="40" style={{ width: "100%", maxWidth: 170, height: "auto", padding: 10 }} />
              </Link>
            </Grid>
            <Grid
              size={{ xs: 12, md: 4 }}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 2
              }}>
              <Link href={`${externalLink}/terms-conditions`} style={{ textDecoration: "none", color: "#ffffff" }} data-qa="footer-terms">
                Terms
              </Link>
              <Link href={`${externalLink}/privacy-policy`} style={{ textDecoration: "none", color: "#ffffff" }} data-qa="footer-privacy">
                Privacy
              </Link>
              <Typography variant="body2" sx={{ color: "white" }}>
                ©{currentYear}, Tellwell Talent
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}

export default Footer;
